import styled, { css } from 'styled-components';
import { Typography } from '~/ui/components';
import { themeColor, themeToggleColor } from '~/common/utils/theme';

type BodyProps = {
  hasHeader: boolean;
};

type GridProps = {
  columns: number;
};

export const CardContainer = styled.div`
  position: relative;
  padding: 16px 20px;
  border-radius: 12px;
  border: 1px solid ${themeColor('element.placeholder')};
  background-color: ${themeColor('background.primary', { dark: 'background.secondary' })};
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 5px;
    border-radius: 0px;
    background: ${({ theme }) => theme.colors.brand.primary};
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
`;

export const Title = styled(Typography).attrs(({ theme }) => ({
  type: 'paragraphSmall',
  element: 'span',
  weight: 700,
  color: themeToggleColor(theme, 'element.secondary'),
}))`
  display: inline-flex;
  align-items: center;
`;

export const HeaderAction = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

export const Body = styled.div<BodyProps>`
  display: flex;
  flex-direction: column;
  gap: 16px;

  ${({ hasHeader }) =>
    hasHeader &&
    css`
      margin-top: 12px;
      padding-top: 12px;
      border-top: 1px solid ${themeColor('divider.primary')};
    `}
`;

export const ItemsGrid = styled.div<GridProps>`
  display: grid;
  grid-template-columns: repeat(${({ columns }) => columns}, minmax(0, 1fr));
  gap: 16px 32px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
`;

export const Item = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ItemLabel = styled(Typography).attrs(({ theme }) => ({
  type: 'caption',
  element: 'span',
  weight: 600,
  color: themeToggleColor(theme, 'element.secondary', { dark: 'element.primary' }),
}))`
  text-transform: none;
`;

export const ItemValue = styled(Typography).attrs(({ theme }) => ({
  type: 'bodySmall',
  element: 'span',
  color: themeToggleColor(theme, 'element.primary', { dark: 'element.secondary' }),
}))`
  word-break: break-word;
`;

export const ItemHelper = styled(Typography).attrs(({ theme }) => ({
  type: 'description',
  element: 'span',
  color: themeToggleColor(theme, 'element.secondary', { dark: 'element.primary' }),
}))`
  opacity: 0.8;
`;

export const CardFooter = styled.div`
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid ${themeColor('divider.primary')};
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
`;
